import { z } from 'zod';

export const fundingSourceSchema = z.object({
  code: z
    .string({ required_error: 'Le code est requis' })
    .min(1, 'Le code ne doit pas être vide')
    .max(250, 'Le code ne doit pas dépasser 250 caractères'),
  description: z
    .string({
      required_error: 'La description est requise',
    })
    .min(1, 'La description ne doit pas être vide')
    .max(250, 'La description ne doit pas dépasser 250 caractères'),
  bailleurDeFonds: z.boolean({ required_error: 'Le bailleur de fonds est requis' }),
});
